module.exports = __webpack_public_path__ + "static/media/crewstudio_app_login_h.b339f5e3.jpg";